import { FC } from 'react';
import { FormControl, GridLegacy as Grid } from "@mui/material";

import DateField from '../../../editable/EditableField/fields/DateField';
import { Nullable } from '../../../../types/utility';


interface IDatePickerProps {
  minDate?: Date;
  maxDate?: Date;
  onChangeDate: (value: Nullable<Date>) => void;
  placeholderText?: string;
  value?: Nullable<string>;
  label?: string;
}

export const DatePicker: FC<IDatePickerProps> = ({ onChangeDate, value, label, minDate, maxDate }) => {
  const handleChange = (newValue: Nullable<string>) => {
    if (newValue === null) {
      onChangeDate(null);
    } else {
      try {
        const dateObject = new Date(newValue);
        if (!isNaN(dateObject.getTime())) {
          onChangeDate(dateObject);
        } else {
          onChangeDate(null);
        }
      } catch (error) {
        onChangeDate(null);
      }
    }
  };

  return (
    <Grid item sm={4} md={2}>
      <FormControl sx={{ minWidth: 160 }} size="small" fullWidth>
        <DateField
          label={label || ""}
          value={value || ""}
          onChange={handleChange}
          testId="criteria-date-picker"
          minDate={minDate}
          maxDate={maxDate}
        />
      </FormControl>
    </Grid>
  );
};

export default DatePicker;
